export default {
  title: "Редактирование профиля",
  personalData: "Личные данные",
  companyData: "Данные компании",

  companyTypes: "Вид деятельности",
  companySizes: "Выберите, если это относится к Вашей компании",
  companyScope: "Сфера деятельности вашей компании",
  companyProductRole: "Область применения Вашей продукции",

  changePassword: "Изменить пароль",
  changePasswordTitle: "Изменение пароля",
  oldPassword: "Текущий пароль",
  newPassword: "Новый пароль",
  passwordConfirmation: "Подтверждение пароля",
  changePasswordSuccess: "Пароль успешно изменен",

  save: "Сохранить",
  saveSuccess: "Успешно сохранено",
  saving: "Сохранение...",

  saveError: "Не удалось обновить профиль: {err}",

  changePasswordWrongOldPasswordError: "Старый пароль введен неверно",
  changePasswordServerError: "Не удалось изменить пароль"
};
